














import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch }from 'vue-property-decorator';
import Loader from "@/components/Loader.vue"

@Component({
	name: "confirmation",
	components: {
		Loader
	}
})
export default class EBiennialConfirmation extends Vue {
    private store: any = this.$store;
    private newObject: any = {};
    private tempTransactionId: any;
    private paymentResultMessage: any;
    private tempTransactionObjectFromBatabase:any={};
    private isEditing:boolean=false;
    private isFromFix:boolean=false;
    private queryParams:any;
    private beforeCreate():void{
      console.log('invoke beforeCreate in confirmation.vue')
      //alert('came to beforeCreate');
      //window.addEventListener("onbeforeunload", this.preventNav);
      //window.addEventListener("onkeydown", this.preventNav);
      //window.addEventListener("beforeunload", this.preventNav);
      //window.addEventListener("beforeunload", this.preventNav);
      //this.isEditing = true;
    //   history.pushState(null, null, location.href);
    //   window.onpopstate = () => {
    //   history.go(1);
    // };
    console.log('into before create')
    console.log(this.$route.query);

    }
    private beforeDestroy():void{
    console.log('invoke beforeDestroy in confirmation.vue')
    //alert('before destroy is being called');
     this.isEditing = false;
     //window.removeEventListener("beforeunload", this.preventNav);
     //window.onpopstate = null;
    }

    private preventNav(event) {
      console.log('checking the editing value in preventNav method:'+this.isEditing)
        // if (!this.isEditing) {
        //   console.log('')
        //   return;
        // }
        //alert('preventing navigation');
        event.preventDefault()
        event.returnValue = ""
    }
    private created(): void {
    console.log('into created')
    console.log(this.$route.query);

      this.isEditing = (sessionStorage.getItem("is_edited") === 'true');
      //alert('is being edited:'+this.isEditing);
      if(!this.isEditing){
        sessionStorage.setItem("is_edited", 'true');
        console.log('value of MDD1');
        console.log(this.$route.query.merchant_defined_data1);
        if(this.$route.query.merchant_defined_data1  !== undefined){
          this.isFromFix = true;
        }
        console.log('this.isFromFix:' + this.isFromFix);
        console.log('first time edit is true. going to send the transaction');
        this.isEditing = true;
        const store = this.$store;
        const http = this.$http;
        this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
        console.log(this.newObject);
        console.log('query values:');
        console.log(this.$route.query);
        console.log('param values:');
        console.log(this.$route.params);
        console.log('stringify query' + JSON.stringify(this.$route.query));
        //this.tempTransactionId = this.$route.query.merchant_defined_data1;
        if(this.isFromFix){
          this.tempTransactionId = this.$route.query.merchant_defined_data1;
          this.paymentResultMessage=this.$route.query.ssl_result_message;
        }else{
          var keys = Object.keys( this.$route.query );
          this.queryParams = JSON.parse(keys[0]);
          console.log(this.queryParams);
          this.tempTransactionId = this.queryParams.merchant_defined_data1;
          this.paymentResultMessage=this.queryParams.ssl_result_message;
        }
        console.log('this.paymentResultMessage:' + this.paymentResultMessage);
        this.logInformationAfterPayment('After redirecting from payment and after storing the record in temp table. Merchant defined data1:'+this.tempTransactionId+'DOSID:'+this.$route.query.merchant_defined_data2) 
        this.logInformationAfterPayment(this.$route.query) 
        console.log('tempTransactionId:' + this.tempTransactionId);
        if(this.isFromFix){
          if (this.empty(this.tempTransactionId) || this.empty(this.$route.query) || this.empty(this.$route.query.ssl_result_message)
          || this.$route.query.ssl_result_message !== 'APPROVAL') {
              this.$router.push({ name: 'denied', params: {cardDeclined: 'false'}});
          }
        }else{
          if (this.empty(this.tempTransactionId) || this.empty(this.$route.query) || this.empty(this.queryParams.ssl_result_message)
          || this.queryParams.ssl_result_message !== 'APPROVAL') {
              this.$router.push({ name: 'denied', params: {cardDeclined: 'false'}});
          }

        }


// this.tempTransactionId = 12;
        this.getTransactionData().then((saveTransactionResponse: any) => {
            this.logInformationAfterPayment('After getting the request from temp transaction table for  merchant defined data1 and DOSID. Merchant defined data1:'+this.tempTransactionId+' DOSID:'+this.$route.query.merchant_defined_data2) 
            this.tempTransactionObjectFromBatabase = saveTransactionResponse;
            console.log('after fetching the value from database');
            console.log(this.tempTransactionObjectFromBatabase);
            this.tempTransactionObjectFromBatabase.payment = {};
            this.tempTransactionObjectFromBatabase.payment.creditCardInfo = {};
            if (this.paymentResultMessage === 'APPROVAL') {
                if(this.isFromFix){
                  this.populatePaymentData(this.$route.query, this.tempTransactionObjectFromBatabase);
                }else{
                  this.populatePaymentData(this.queryParams, this.tempTransactionObjectFromBatabase);
                }
                console.log('Before going to save the final transaction');
                console.log(this.tempTransactionObjectFromBatabase);
                this.saveFinalTransaction().then((finalResponse: any) => {
                this.logInformationAfterPayment('After saving the final transaction for the following merchant defined data1 and DOSID. Merchant defined data1:'+this.tempTransactionId+' DOSID:'+this.$route.query.merchant_defined_data2) 
                console.log(finalResponse);
                this.populateFilingInfo(this.tempTransactionObjectFromBatabase);
                this.newObject.transmittalDatetime = this.getNNowDatetime();
                store.commit('ebiennial/setEBiennialData', this.newObject);
                if (finalResponse.ebiennialFilingResult.requestStatus==='Success') {
                      //alert('came to success');
                      sessionStorage.setItem("is_edited", 'false');
                      sessionStorage.setItem("is_Success", 'true');
                      this.$router.push({ name: 'approved' });
                } else {
                  //alert('came to error');
                    sessionStorage.setItem("is_edited", 'false');
                    sessionStorage.setItem("is_error", 'true');
                    sessionStorage.setItem("ErrorCode", finalResponse.ebiennialFilingResult.ErrorCode);
                    if (finalResponse.ebiennialFilingResult.ErrorCode === 'EBI104'){
                      this.$router.push({ name: 'issue',params: {issueBO: 'false'} });
                    }else{
                      this.$router.push({ name: 'issue',params: {issueBO: 'true'} });
                    }

                  }
                }).catch((error: any) => {
                console.log(error);
                sessionStorage.setItem("is_edited", 'false');
                this.$router.push({ name: 'issue',params: {issueBO: 'false'}  });
                });
            } else {
                store.commit('ebiennial/setEBiennialData', this.newObject);
                sessionStorage.setItem("is_edited", 'false');
                this.$router.push({ name: 'denied', params: {cardDeclined: 'true'}});
            }
        });

      }
      else{
        var finalResult = sessionStorage.getItem("is_Success");
        //alert('came to if of being edited:'+finalResult);
        if (finalResult==='true') {
              sessionStorage.setItem("is_edited", 'fasle');
              //sessionStorage.setItem("ebiennialFilingResult", finalResponse.ebiennialFilingResult);
                this.$router.push({ name: 'approved' });
        } else {
          
            var isError = sessionStorage.getItem("is_error");
            var errorCode = sessionStorage.getItem("ErrorCode");
            //alert('came to else of being edited:'+isError);
            if(isError === 'true'){
              if (errorCode === 'EBI104'){
                sessionStorage.setItem("is_edited", 'fasle');
                this.$router.push({ name: 'issue',params: {issueBO: 'false'} });
              }else{
                sessionStorage.setItem("is_edited", 'fasle');
                this.$router.push({ name: 'issue',params: {issueBO: 'true'} });
              }

            }else{
              sessionStorage.setItem("is_edited", 'fasle');
              this.$router.push({ name: 'issue',params: {issueBO: 'true'} });
            }

          }
          sessionStorage.setItem("is_edited", 'fasle');
        console.log('already it is being edited. Cannot do anything now');
      }
    }
    private getTransactionData() {
      return  this.$http.get('Ebiennial/GetTransactionData', {
          params: {
          id: this.tempTransactionId,
        },

        }).then((response: any) => {
            console.log('after getting response from temporary storage');
            console.log(response);
            console.log(response.data);
            if(response.status == 204){
              this.$router.push({ name: 'issue',params: {issueBO: 'true'} });
            }else{
              return response.data;
            }

        }).catch((error: any) => {
            console.log(error);
        });
    }
    private async logInformationAfterPayment(loginformation:any) {
      this.$http.get('Ebiennial/LogInformationToLogFile', {
          params: {
          loggingInfo: loginformation,
        },

        }).then((response: any) => {
            console.log('after getting response from LogInformationToLogFile');
        }).catch((error: any) => {
            console.log(error);
        });
    }

    private populatePaymentData(query: any, ebiennial: any) {
        ebiennial.payment.paymentId = query.ssl_invoice_number;
        ebiennial.payment.paidAmount = query.ssl_amount;
        ebiennial.payment.totalFee = query.ssl_amount;
        ebiennial.payment.paymentMethod = 'CREDITCARD';
        ebiennial.payment.paymentStatus = 'PAID';
        ebiennial.payment.payeeName = query.ssl_first_name + ' ' + query.ssl_last_name;
        ebiennial.payment.paymentReason = 'EBIEENIAL';
        // ebiennial.payment.paymentDate = query.ssl_txn_time;
        ebiennial.payment.paymentDate = new Date();
        ebiennial.payment.paymentComment = '';
   
        ebiennial.payment.creditCardInfo.merchantId = query.show_merchant_id;
        ebiennial.payment.creditCardInfo.cCtransactionId = query.ssl_txn_id;
        ebiennial.payment.creditCardInfo.payeeAddressLine1 = query.ssl_avs_address;
        ebiennial.payment.creditCardInfo.payeeAddressLine2 = query.ssl_address2;
        ebiennial.payment.creditCardInfo.payeeAddressCity = query.ssl_city;
        ebiennial.payment.creditCardInfo.payeeAddressState = query.ssl_state;
        ebiennial.payment.creditCardInfo.payeeAddressZip = query.ssl_avs_zip;
        ebiennial.payment.creditCardInfo.payeeAddressCountry = query.ssl_country;
        ebiennial.payment.creditCardInfo.payeePhone = query.ssl_phone;
        ebiennial.payment.creditCardInfo.payeeEmail = query.ssl_email;
        const cardNumber: string = query.ssl_card_number;
        ebiennial.payment.creditCardInfo.paymentCardNumber = cardNumber.slice(-4);
        ebiennial.payment.creditCardInfo.paymentCardType = query.ssl_card_short_description;
        ebiennial.payment.creditCardInfo.paymentAuthCode = query.ssl_txn_id;
        ebiennial.payment.paymentProviderResponse = JSON.stringify(query);
    }
    private saveFinalTransaction() {
        return this.$http.post('Ebiennial/EBiennialDataFiling', {
                eBiennialFilingRequest: {
                    dosId: this.tempTransactionObjectFromBatabase.dosid,
                    entityName: this.tempTransactionObjectFromBatabase.entityName,
                    entityType: this.tempTransactionObjectFromBatabase.entityType,
                    ceoInfo: this.tempTransactionObjectFromBatabase.ceoInfo,
                    prinExecOfficeInfo: this.tempTransactionObjectFromBatabase.prinExecOfficeInfo,
                    serviceOfProcessInfo: this.tempTransactionObjectFromBatabase.serviceOfProcessInfo,
                    filerInfo: this.tempTransactionObjectFromBatabase.filerInfo,
                    farmCorpExemptionFlag: this.tempTransactionObjectFromBatabase.farmCorpExemptclsionFlag,
                    signatureInfo: this.tempTransactionObjectFromBatabase.signatureInfo,
                    emailForNotification: this.tempTransactionObjectFromBatabase.emailForNotification,
                    paymentInfo: this.tempTransactionObjectFromBatabase.payment,
                    feeAmount:this.tempTransactionObjectFromBatabase.feeAmount,
                    FilingPeriod:this.tempTransactionObjectFromBatabase.filingPeriod,
                    womenBoardMember:this.tempTransactionObjectFromBatabase.womenBoardMember,
                    tempTransactionId:this.tempTransactionId

                },
            }).then((response: any) => {
            return response.data;
            console.log('finished saving data');
            console.log(response);
        }).catch((error: any) => {
            // this.error = error
            console.log(error);
        });
    }
    private getNNowDatetime() {
        const today = new Date();
        const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return  date + ' ' + time;
    }

     private populateFilingInfo(searchResult): void {

     this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));

    console.log('Inside populateFilinginfo');
    console.log(this.newObject);
    console.log(searchResult);
    if (!this.empty(searchResult.ceoInfo.name)) {
      this.newObject.ceo.name = searchResult.ceoInfo.name;
    }
    if (!this.empty(searchResult.ceoInfo.address.streetAddress)) {
      this.newObject.ceo.address.line1 = searchResult.ceoInfo.address.streetAddress;

    }
    if (!this.empty(searchResult.ceoInfo.address.addressLine2)) {
      this.newObject.ceo.address.line2 = searchResult.ceoInfo.address.addressLine2;

    }
    if (!this.empty(searchResult.ceoInfo.address.city)) {
      this.newObject.ceo.address.city = searchResult.ceoInfo.address.city;

    }
    if (!this.empty(searchResult.ceoInfo.address.state)) {
      this.newObject.ceo.address.zipCode = searchResult.ceoInfo.address.state;

    }
    if (!this.empty(searchResult.ceoInfo.address.zipCode)) {
      this.newObject.ceo.address.zipCode = searchResult.ceoInfo.address.zipCode;

    }

    if (!this.empty(searchResult.ceoInfo.address.country)) {
      this.newObject.ceo.address.country = searchResult.ceoInfo.address.country;
    }
    console.log('After setting ceo');
    if (!this.empty(searchResult.prinExecOfficeInfo.name)) {
      this.newObject.prinExecOfficeInfo.name = searchResult.prinExecOfficeInfo.name;

    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.streetAddress)) {
      this.newObject.prinExecOfficeInfo.address.line1 = searchResult.prinExecOfficeInfo.address.streetAddress;
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.addressLine2)) {
      this.newObject.prinExecOfficeInfo.address.line2 = searchResult.prinExecOfficeInfo.address.addressLine2;
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.city)) {
      this.newObject.prinExecOfficeInfo.address.city = searchResult.prinExecOfficeInfo.address.city;
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.state)) {
      this.newObject.prinExecOfficeInfo.address.zipCode = searchResult.prinExecOfficeInfo.address.state;

    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.zipCode)) {
      this.newObject.prinExecOfficeInfo.address.zipCode = searchResult.prinExecOfficeInfo.address.zipCode;

    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.country)) {
      this.newObject.prinExecOfficeInfo.address.country = searchResult.prinExecOfficeInfo.address.country;
    }
    console.log('After setting prinExecOfficeinfo');
    if (!this.empty(searchResult.serviceOfProcessInfo.name)) {
      this.newObject.serviceOfProcessInfo.name = searchResult.serviceOfProcessInfo.name;

    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.streetAddress)) {
      this.newObject.serviceOfProcessInfo.address.line1 = searchResult.serviceOfProcessInfo.address.streetAddress;
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.addressLine2)) {
      this.newObject.serviceOfProcessInfo.address.line2 = searchResult.serviceOfProcessInfo.address.addressLine2;
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.city)) {
      this.newObject.serviceOfProcessInfo.address.city = searchResult.serviceOfProcessInfo.address.city;

    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.state)) {
      this.newObject.serviceOfProcessInfo.address.state = searchResult.serviceOfProcessInfo.address.state;

    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.zipCode)) {
      this.newObject.serviceOfProcessInfo.address.zipCode = searchResult.serviceOfProcessInfo.address.zipCode;

    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.country)) {
      this.newObject.serviceOfProcessInfo.address.country = searchResult.serviceOfProcessInfo.address.country;
    }
    console.log('After setting serviceofProcessinfo');
    console.log(searchResult.womenBoardMember);
    console.log(this.empty(searchResult.womenBoardMember));
    if(searchResult.womenBoardMember){
        if (!this.empty(searchResult.womenBoardMember.totalNumberOfBoardMembers)) {
        this.newObject.womanBoardMember.totalBoardMemberNumber = searchResult.womenBoardMember.totalNumberOfBoardMembers;
        }
        if (!this.empty(searchResult.womenBoardMember.numberOfWomenBoardMembers)) {
        this.newObject.womanBoardMember.totalWomenBoardMemberNumber = searchResult.womenBoardMember.numberOfWomenBoardMembers;
        }
    }

    if(!this.empty(searchResult.farmCorpExemptionFlag)){
      this.newObject.farmCorpExemptionFlag = (searchResult.farmCorpExemptionFlag==='True');
    }else{
      this.newObject.farmCorpExemptionFlag = false;
    }
    

    this.newObject.dosId = searchResult.dosid;
    this.newObject.entityName = searchResult.entityName;
    this.newObject.entityType = searchResult.entityType;
    this.newObject.feeAmount = searchResult.feeAmount;
    this.newObject.filingPeriod = searchResult.filingPeriod;
    this.newObject.emailForEBiennial = searchResult.emailForNotification;
    this.newObject.payment = searchResult.payment;
    console.log('After filling up the object');
    console.log(this.newObject);

  }
  // private beforeCreate(): void {
  //   history.pushState(null, null, location.href);
  //   window.onpopstate = () => {
  //     history.go(1);
  //   };
  // }
  // private beforeDestroy(): void {
  //   window.onpopstate = null;
  // }

    private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
}
